<div class="title-container title-background">
  <div (click)="goTo(1)"  class="{{(secondTitle ? 'title mat-headline-6 cursor pl' : 'title mat-headline-5 cursor pl')}}" i18n-aria-label aria-label="{{firstTitle}}">{{firstTitle}}</div>
  <div class="title mat-headline-6 ">
    @if (secondTitle) {
      <mat-icon class="title pl-16" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
    }
  </div>
  <div (click)="goTo(2)" class="{{(thirdTitle ? 'title mat-headline-6 cursor pl-16' : 'title mat-headline-5 cursor pl-16')}}" i18n-aria-label aria-label="{{secondTitle}}">{{secondTitle}}</div>
  <div class="title mat-headline-6 ">
    @if (thirdTitle) {
      <mat-icon class="title pl-16" i18n-aria-label aria-label="Next">keyboard_arrow_right</mat-icon>
    }
  </div>
  <div (click)="goTo(3)" class="title mat-headline-5 cursor pl-16" i18n-aria-label aria-label="{{thirdTitle}}">{{thirdTitle}}</div>
</div>